<fgbcl-game-banner></fgbcl-game-banner>
<div class="container">
  <h4 class="font-weight-bold text-primary mb-4">SELECTED Ticket(S)</h4>
  <fgbcl-selected-tickets-table
    [showRemoveButton]="true"
  ></fgbcl-selected-tickets-table>
  <h4 class="font-weight-bold text-primary mb-4">TRANSFER TO</h4>
  <fgbcl-transfer-form></fgbcl-transfer-form>
</div>
